<div class="rebilling-tab">

  <p-confirmDialog [baseZIndex]="10000" key="generateRebillingCD" styleClass="delete-confirm-dialog"></p-confirmDialog>
  <p-confirmDialog [baseZIndex]="10000" key="deleteNoteCD" styleClass="delete-confirm-dialog"></p-confirmDialog>

  <div class="rebilling-toolbar">
    <div class="toolbar-field toolbar-field--year">
      <p-floatLabel>
        <input (change)="changeYear()" [(ngModel)]="year" id="rebillingYear" min="2000" pInputText type="number">
        <label for="rebillingYear">Year</label>
      </p-floatLabel>
    </div>
    <button (click)="confirmGenerate()" class="primary-btn" type="button">
      <i aria-hidden="true" class="fa fa-refresh"></i>
      Generate {{ year }}
    </button>
    <span *ngIf="generateResult" class="rebilling-result">{{ generateResult }}</span>
    <div class="rebilling-export">
      <div class="toolbar-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" [(ngModel)]="groupBy" [options]="groupByOptions" [showClear]="true" inputId="rebillingGroupBy"></p-dropdown>
          <label for="rebillingGroupBy">Group by (optional)</label>
        </p-floatLabel>
      </div>
      <button (click)="exportWorkbook()" class="secondary-btn" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>
        {{ activeFilterCount ? 'Export filtered (' + activeFilterCount + ')' : 'Export all' }}
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="portal-alert portal-alert--danger">
    <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
    {{ errorMessage }}
  </div>

  <p-panel [toggleable]="true">
    <ng-template pTemplate="header">
      <div class="filter-card-header">
        <span class="filter-icon"><i class="fa fa-search"></i></span>
        <span class="filter-card-title">Filter</span>
      </div>
    </ng-template>
    <div class="filter-fields">
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="loadLines(); loadNotes()" [(ngModel)]="filters.exchange" [options]="exchanges"
                      [showClear]="true" inputId="rebillingExchange"></p-dropdown>
          <label for="rebillingExchange">Exchange</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="loadLines()" [(ngModel)]="filters.company" [filter]="true" [options]="companies"
                      [showClear]="true" inputId="rebillingCompany"></p-dropdown>
          <label for="rebillingCompany">Company</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="loadLines()" [(ngModel)]="filters.billingAccount" [filter]="true" [options]="accounts"
                      [showClear]="true" inputId="rebillingAccount"></p-dropdown>
          <label for="rebillingAccount">Account</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="loadLines()" [(ngModel)]="filters.dadProduct" [filter]="true" [options]="products"
                      [showClear]="true" inputId="rebillingProduct"></p-dropdown>
          <label for="rebillingProduct">Product</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="loadLines()" [(ngModel)]="filters.entity" [filter]="true" [options]="entities" [showClear]="true"
                      inputId="rebillingEntity"></p-dropdown>
          <label for="rebillingEntity">Contracting entity</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="loadLines()" [(ngModel)]="filters.status" [filter]="true" [options]="statuses" [showClear]="true"
                      inputId="rebillingStatus"></p-dropdown>
          <label for="rebillingStatus">Status</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--period">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="clearPeriod('month')" [(ngModel)]="filters.month" [options]="months" [showClear]="true"
                      inputId="rebillingMonth"></p-dropdown>
          <label for="rebillingMonth">Month</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--period">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" (onChange)="clearPeriod('quarter')" [(ngModel)]="filters.quarter" [options]="quarters"
                      [showClear]="true" inputId="rebillingQuarter"></p-dropdown>
          <label for="rebillingQuarter">Quarter</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--check">
        <p-checkbox (onChange)="loadLines()" [(ngModel)]="filters.exceptionsOnly" [binary]="true"
                    inputId="exceptionsOnly" label="Exceptions only"></p-checkbox>
      </div>
      <div class="filter-actions">
        <button (click)="resetFilters()" class="secondary-btn" type="button">
          <i aria-hidden="true" class="fa fa-refresh"></i>
          Reset
        </button>
      </div>
    </div>
  </p-panel>

  <p-tabView [(activeIndex)]="activeView" styleClass="rebilling-views">
    <p-tabPanel header="Lines ({{ lines.length }})">
      <div *ngIf="selectedLines.length > 0" class="rebilling-bulk">
        <span class="rebilling-bulk-count">{{ selectedLines.length }} selected</span>
        <div class="toolbar-field">
          <p-floatLabel>
            <p-dropdown appendTo="body" panelStyleClass="portal-overlay" [(ngModel)]="bulkStatus" [options]="statuses" inputId="rebillingBulkStatus"></p-dropdown>
            <label for="rebillingBulkStatus">Set status</label>
          </p-floatLabel>
        </div>
        <button (click)="applyStatus()" [disabled]="!bulkStatus" class="primary-btn" type="button">
          <i aria-hidden="true" class="fa fa-check"></i>
          Apply
        </button>
      </div>

      <p-table [(selection)]="selectedLines" [paginator]="true" [rows]="50" [value]="lines" dataKey="id">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th>Month</th>
            <th>Exchange</th>
            <th>Account</th>
            <th>Product</th>
            <th>Rebilling type</th>
            <th>Order form</th>
            <th>Entity</th>
            <th>Qty</th>
            <th>Unit price</th>
            <th>Fee</th>
            <th>Status</th>
            <th>Exceptions</th>
          </tr>
        </ng-template>
        <ng-template let-line pTemplate="body">
          <tr [class.rebilling-row-flash]="flashedLineIds.has(line.id)" [class.rebilling-row-high]="hasHighException(line)">
            <td><p-tableCheckbox [value]="line"></p-tableCheckbox></td>
            <td class="when-cell">{{ line.usageMonth | date:'MMM yyyy' }}</td>
            <td>{{ line.exchange }}</td>
            <td class="record-cell">{{ line.billingAccount?.name }}</td>
            <td>{{ line.internalProductCode || line.productCode }}</td>
            <td>{{ line.rebillingProductType }}</td>
            <td>{{ line.orderForm?.identificationNumber }}</td>
            <td>{{ line.contractingEntity?.name }}</td>
            <td>{{ line.quantity }}</td>
            <td>{{ line.priceCurrency ? (line.unitPrice | currency:line.priceCurrency:'symbol':'1.2-4') : (line.unitPrice | number:'1.2-4') }}</td>
            <td>{{ line.priceCurrency ? (line.fee | currency:line.priceCurrency:'symbol':'1.2-2') : (line.fee | number:'1.2-2') }}</td>
            <td><span [ngClass]="statusClass(line.billingStatus)" class="status-pill">{{ line.billingStatus }}</span></td>
            <td>
              <span *ngFor="let exception of line.exceptions"
                    [class.rebilling-badge-high]="exception.severity === 'High'"
                    class="rebilling-badge">{{ exception.code }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="13">
              <div class="empty-state">
                <i aria-hidden="true" class="fa fa-search"></i>
                <div class="empty-state-title">No lines for {{ year }}</div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <ng-container *ngIf="sheets">
      <p-tabPanel *ngFor="let sheet of sheets.sheets; trackBy: trackByExchange" header="{{ sheet.exchange }} ({{ sheet.rows.length }})">
        <p-table [scrollable]="true" [value]="sheet.rows" styleClass="rebilling-sheet">
          <ng-template pTemplate="header">
            <tr>
              <th pFrozenColumn class="sheet-account" rowspan="2">Account</th>
              <th pFrozenColumn class="sheet-product sheet-frozen-edge" rowspan="2">Product</th>
              <th rowspan="2">1st configured</th>
              <th rowspan="2">Deconfigured</th>
              <th rowspan="2">Order form</th>
              <th rowspan="2">Order form currency</th>
              <th rowspan="2">Invoicing currency</th>
              <th rowspan="2">Contracting entity</th>
              <th *ngFor="let month of months" class="sheet-period" colspan="2">{{ month.label }} {{ year }}</th>
              <th class="sheet-period" colspan="2">YTD</th>
            </tr>
            <tr>
              <ng-container *ngFor="let period of periodColumns">
                <th class="sheet-qty">Qty</th>
                <th class="sheet-fee">Fee</th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template let-row pTemplate="body">
            <tr>
              <td pFrozenColumn [title]="row.account" class="record-cell sheet-account">{{ row.account }}</td>
              <td pFrozenColumn [style.background]="row.productColor ? '#' + row.productColor : null" class="sheet-product sheet-frozen-edge">{{ row.product }}</td>
              <td [class.sheet-changed]="row.firstConfiguredThisYear">{{ row.firstConfigured }}</td>
              <td>{{ row.deconfigured }}</td>
              <td>
                <a *ngIf="row.orderForm?.url; else orderFormText" [href]="row.orderForm.url" rel="noopener" target="_blank">{{ row.orderForm.number }}</a>
                <ng-template #orderFormText>{{ row.orderForm?.number }}</ng-template>
              </td>
              <td>{{ row.orderFormCurrency }}</td>
              <td>{{ row.priceCurrency }}</td>
              <td>{{ row.contractingEntity }}</td>
              <ng-container *ngFor="let cell of row.months">
                <td [attr.title]="cellTitle(cell)" [class.sheet-changed]="cell.changed" [class.sheet-incomplete]="cell.incomplete" [class.sheet-not-billable]="cell.notBillable || cell.selfReported || cell.noDad" class="sheet-qty">{{ cell.quantity }}</td>
                <td [attr.title]="cellTitle(cell)" [class.sheet-incomplete]="cell.incomplete" [class.sheet-not-billable]="cell.notBillable || cell.selfReported || cell.noDad" class="sheet-fee">{{ formatFee(cell.fee, row.priceCurrency) }}</td>
              </ng-container>
              <td [attr.title]="row.ytd.incomplete ? incompleteTitle : null" [class.sheet-incomplete]="row.ytd.incomplete" class="sheet-qty">{{ row.ytd.quantity }}</td>
              <td [attr.title]="row.ytd.incomplete ? incompleteTitle : null" [class.sheet-incomplete]="row.ytd.incomplete" class="sheet-fee">{{ formatFee(row.ytd.fee, row.priceCurrency) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <ng-container *ngIf="sheet.rows.length > 0">
              <tr *ngFor="let total of sheet.totals">
                <td pFrozenColumn class="sheet-account"></td>
                <td pFrozenColumn class="sheet-product sheet-frozen-edge"></td>
                <td colspan="6" class="sheet-total-label">Total {{ total.currency }}</td>
                <ng-container *ngFor="let month of total.months">
                  <td [attr.title]="month.incomplete ? incompleteTitle : null" [class.sheet-incomplete]="month.incomplete" class="sheet-qty">{{ month.quantity }}</td>
                  <td [attr.title]="month.incomplete ? incompleteTitle : null" [class.sheet-incomplete]="month.incomplete" class="sheet-fee">{{ formatFee(month.fee, total.currency) }}</td>
                </ng-container>
                <td [attr.title]="total.ytd.incomplete ? incompleteTitle : null" [class.sheet-incomplete]="total.ytd.incomplete" class="sheet-qty">{{ total.ytd.quantity }}</td>
                <td [attr.title]="total.ytd.incomplete ? incompleteTitle : null" [class.sheet-incomplete]="total.ytd.incomplete" class="sheet-fee">{{ formatFee(total.ytd.fee, total.currency) }}</td>
              </tr>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="34">
                <div class="empty-state">
                  <i aria-hidden="true" class="fa fa-table"></i>
                  <div class="empty-state-title">No {{ sheet.exchange }} lines for {{ year }}</div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Exceptions ({{ sheets.exceptions.length }})">
        <p-table [paginator]="true" [rows]="50" [value]="sheets.exceptions">
          <ng-template pTemplate="header">
            <tr>
              <th>Month</th>
              <th>Exchange</th>
              <th>Company</th>
              <th>Account</th>
              <th>Product</th>
              <th>Order form</th>
              <th>Exception</th>
              <th pSortableColumn="severity">Severity
                <p-sortIcon field="severity"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template let-exception pTemplate="body">
            <tr [class.rebilling-row-high]="exception.severity === 'High'">
              <td class="when-cell">{{ exception.usageMonth + '-01' | date:'MMM yyyy' }}</td>
              <td>{{ exception.exchange }}</td>
              <td>{{ exception.company }}</td>
              <td class="record-cell">{{ exception.account }}</td>
              <td>{{ exception.product }}</td>
              <td>{{ exception.orderForm }}</td>
              <td>{{ exception.code }}</td>
              <td><span [class.rebilling-badge-high]="exception.severity === 'High'" class="rebilling-badge">{{ exception.severity }}</span></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">
                <div class="empty-state">
                  <i aria-hidden="true" class="fa fa-check-circle"></i>
                  <div class="empty-state-title">No exceptions for {{ year }}</div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </ng-container>
  </p-tabView>

  <p-panel [toggleable]="true">
    <ng-template pTemplate="header">
      <div class="filter-card-header">
        <span class="filter-icon"><i class="fa fa-sticky-note-o"></i></span>
        <span class="filter-card-title">Notes {{ year }}<span *ngIf="filters.exchange"> · {{ filters.exchange }}</span></span>
      </div>
    </ng-template>
    <div *ngIf="successMessage" class="portal-alert portal-alert--success rebilling-note-alert">
      <i aria-hidden="true" class="fa fa-check-circle"></i>
      {{ successMessage }}
      <button (click)="successMessage = null" aria-label="Close" class="portal-alert-close" type="button">&times;</button>
    </div>
    <div class="filter-fields">
      <div class="filter-field">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" [(ngModel)]="newNote.billingAccount" [filter]="true" [options]="accounts"
                      inputId="noteAccount"></p-dropdown>
          <label for="noteAccount">Account</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--period">
        <p-floatLabel>
          <p-dropdown appendTo="body" panelStyleClass="portal-overlay" [(ngModel)]="newNote.exchange" [options]="exchanges" inputId="noteExchange"></p-dropdown>
          <label for="noteExchange">Exchange</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--period">
        <p-floatLabel>
          <p-calendar appendTo="body" [(ngModel)]="newNote.noteDate" dateFormat="dd/mm/yy" inputId="noteDate"
                      panelStyleClass="sym-datepicker sym-datepicker-sm portal-datepicker"></p-calendar>
          <label for="noteDate">Date</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--note">
        <p-floatLabel>
          <input (keyup.enter)="saveNote()" [(ngModel)]="newNote.text" id="noteText" pInputText type="text">
          <label for="noteText">Note</label>
        </p-floatLabel>
      </div>
      <div class="filter-actions">
        <button (click)="saveNote()" [disabled]="!canSaveNote" class="primary-btn" type="button">
          <i [class.fa-check]="editingNoteId" [class.fa-plus-circle]="!editingNoteId" aria-hidden="true" class="fa"></i>
          {{ editingNoteId ? 'Save note' : 'Add note' }}
        </button>
        <button (click)="cancelEdit()" *ngIf="editingNoteId" class="secondary-btn" type="button">Cancel</button>
      </div>
    </div>
    <p-table [value]="notes" styleClass="notes-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 8rem">Date</th>
          <th style="width: 7rem">Exchange</th>
          <th style="width: 14rem">Account</th>
          <th>Note</th>
          <th style="width: 5.5rem"></th>
        </tr>
      </ng-template>
      <ng-template let-note pTemplate="body">
        <tr [class.rebilling-note-editing]="note.id === editingNoteId">
          <td class="when-cell">{{ note.noteDate | date:'dd/MM/yyyy' }}</td>
          <td>{{ note.exchange }}</td>
          <td class="record-cell">{{ note.billingAccount.name }}</td>
          <td>{{ note.text }}</td>
          <td class="note-actions">
            <button (click)="editNote(note)" aria-label="Edit note" class="icon-btn" type="button">
              <i class="fa fa-pencil"></i>
            </button>
            <button (click)="confirmDeleteNote(note)" aria-label="Delete note" class="icon-btn" type="button">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="empty-state">
              <i aria-hidden="true" class="fa fa-sticky-note-o"></i>
              <div class="empty-state-title">No notes for {{ year }}</div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>

</div>
